import comp from "./CompactAudioWaveformPlayer";
export default comp;
